import axios from "./axios";
export default {
    xuid(gamertag){
        return axios.get("/api/black/utils/xuid/get",{
            params:{
                gamertag
            }
        });
    },
    openapiToken(){
        return axios.get("/api/user/api_token/get")
    }
}